/**
 * Tiny reusable building blocks shared across the new pages.
 * Kept in one file so we don't pollute the components folder with
 * one-off marketing primitives.
 */

export function PageHeader({ eyebrow, title, italicTail, intro, children }) {
  return (
    <section className="relative pt-32 pb-16 lg:pt-44 lg:pb-24 bg-cream overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {eyebrow && (
          <div
            className="text-xs tracking-overline uppercase font-semibold text-accent-gold mb-6"
            data-testid="page-header-eyebrow"
          >
            {eyebrow}
          </div>
        )}
        <h1
          className="font-serif font-light text-deep-teal leading-[1.04] tracking-tight max-w-5xl"
          style={{ fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)" }}
          data-testid="page-header-title"
        >
          {title}
          {italicTail && (
            <>
              {" "}
              <span className="italic text-accent-gold">{italicTail}</span>
            </>
          )}
        </h1>
        {intro && (
          <p className="mt-8 max-w-3xl text-lg text-charcoal-teal leading-relaxed">
            {intro}
          </p>
        )}
        {children}
      </div>
      <div className="pointer-events-none absolute -bottom-20 -right-20 w-[26rem] h-[26rem] rounded-full bg-accent-gold/5 blur-3xl" />
    </section>
  );
}

export function SectionLabel({ index, label }) {
  return (
    <div className="flex items-center gap-3 mb-6">
      <span className="text-xs tracking-overline uppercase font-semibold text-accent-gold">
        § {index}
      </span>
      <span className="h-px w-10 bg-accent-gold/60" />
      <span className="text-xs tracking-overline uppercase font-semibold text-deep-teal/70">
        {label}
      </span>
    </div>
  );
}

export function SectionHeading({ children, italicTail }) {
  return (
    <h2
      className="font-serif font-light text-deep-teal leading-[1.05] tracking-tight max-w-4xl"
      style={{ fontSize: "clamp(2rem, 4.4vw, 3.75rem)" }}
    >
      {children}
      {italicTail && (
        <>
          {" "}
          <span className="italic text-accent-gold">{italicTail}</span>
        </>
      )}
    </h2>
  );
}
